/* Casa Facile — consolidated active v15/v16 runtime. Legacy backup assets are not loaded. */
(() => {
/* CF_AUTOPLAY_CONTROLLER_START */
const createCasaFacileAutoplay = (track, options) => {
  const { mobile, reduced, interval, pauseMs, advance, update, dispose } = options;
  const listeners = [];
  let timer = 0;
  let resumeTimer = 0;
  let frame = 0;
  let pausedUntil = 0;
  let inView = !('IntersectionObserver' in window);
  let focusWithin = track.contains(document.activeElement);
  let suspended = false;
  let destroyed = false;

  const listen = (target, type, handler, settings) => {
    target.addEventListener(type, handler, settings);
    listeners.push(() => target.removeEventListener(type, handler, settings));
  };

  const stop = () => {
    window.clearInterval(timer);
    window.clearTimeout(resumeTimer);
    timer = resumeTimer = 0;
  };

  const eligible = () => !destroyed && !suspended && track.isConnected &&
    mobile.matches && !reduced.matches && !document.hidden && inView && !focusWithin;

  const syncTimer = () => {
    stop();
    if (!eligible()) return;
    const remaining = pausedUntil - Date.now();
    if (remaining > 0) {
      resumeTimer = window.setTimeout(syncTimer, remaining);
    } else {
      timer = window.setInterval(() => {
        if (!eligible() || Date.now() < pausedUntil) { syncTimer(); return; }
        advance();
      }, interval);
    }
  };

  const scheduleUpdate = () => {
    if (frame || destroyed || suspended || document.hidden) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      if (!destroyed && track.isConnected) update();
    });
  };

  const refresh = () => { scheduleUpdate(); syncTimer(); };
  const pauseForUser = () => { pausedUntil = Date.now() + pauseMs; syncTimer(); };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target !== track) return;
      inView = entry.isIntersecting && entry.intersectionRatio >= .18;
      syncTimer();
    });
  }, { threshold: [0, .18] }) : null;

  const destroy = () => {
    if (destroyed) return;
    destroyed = true;
    stop();
    window.cancelAnimationFrame(frame);
    observer?.disconnect();
    listeners.forEach((remove) => remove());
    dispose?.();
  };

  listen(track, 'scroll', scheduleUpdate, { passive: true });
  ['pointerdown', 'touchstart', 'wheel'].forEach((type) => listen(track, type, pauseForUser, { passive: true }));
  listen(track, 'keydown', pauseForUser);
  listen(track, 'focusin', () => { focusWithin = true; pauseForUser(); });
  listen(track, 'focusout', (event) => {
    if (event.relatedTarget && track.contains(event.relatedTarget)) return;
    focusWithin = false;
    pauseForUser();
  });
  listen(document, 'visibilitychange', refresh);
  listen(window, 'resize', scheduleUpdate, { passive: true });
  listen(window, 'pagehide', () => { suspended = true; stop(); window.cancelAnimationFrame(frame); frame = 0; });
  listen(window, 'pageshow', () => { suspended = false; refresh(); });
  listen(document, 'shopify:section:unload', (event) => {
    if (event.target === track || event.target?.contains(track)) destroy();
  });
  [mobile, reduced].forEach((query) => {
    if (query.addEventListener) listen(query, 'change', refresh);
    else if (query.addListener) {
      query.addListener(refresh);
      listeners.push(() => query.removeListener(refresh));
    }
  });
  observer?.observe(track);
  refresh();
  return destroy;
};
/* CF_AUTOPLAY_CONTROLLER_END */
/* ==========================================================================\n   CASA FACILE — V15.1 TOP\n   Faster mobile auto-carousel + slightly more compact cards + clearer motion.\n   Additive only: no content, links, products or publication changes.\n   ========================================================================== */
(() => {
  if (window.CasaFacileHomeFxV151) return;
  window.CasaFacileHomeFxV151 = true;

  const body = document.body;
  if (!body?.classList.contains('template-casa-facile-shop')) return;

  const mobileMq = window.matchMedia('(max-width: 649px)');
  const reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initializedTracks = new WeakSet();
  const AUTO_MS = 2600;
  const USER_PAUSE_MS = 5000;

  const injectStyles = () => {
    document.getElementById('cf-v15-home-effects')?.remove();
    if (document.getElementById('cf-v151-home-effects')) return;

    const style = document.createElement('style');
    style.id = 'cf-v151-home-effects';
    style.textContent = `
      /* HERO — premium animated CTAs */
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange{
        position:relative!important;
        isolation:isolate;
        overflow:hidden!important;
        border:1px solid rgba(255,255,255,.18)!important;
        background:linear-gradient(110deg,#f57c20 0%,#ff9f48 42%,#ffc06b 55%,#f57c20 100%)!important;
        background-size:230% 100%!important;
        color:#102f3a!important;
        box-shadow:0 12px 28px rgba(245,124,32,.28),0 0 0 1px rgba(255,255,255,.05) inset!important;
        transition:transform .28s ease,box-shadow .28s ease,filter .28s ease!important;
        animation:cfV15OrangeFlow 4.6s ease-in-out infinite!important;
      }
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange::before{
        content:"";
        position:absolute;
        inset:-35% auto -35% -35%;
        width:28%;
        pointer-events:none;
        transform:skewX(-18deg) translateX(-220%);
        background:linear-gradient(90deg,transparent,rgba(255,255,255,.46),transparent);
        animation:cfV15Shine 4.9s ease-in-out infinite;
        z-index:-1;
      }
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange:hover,
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange:focus-visible{
        transform:translateY(-2px) scale(1.012)!important;
        filter:saturate(1.05) brightness(1.03)!important;
        box-shadow:0 17px 36px rgba(245,124,32,.38),0 0 0 1px rgba(255,255,255,.10) inset!important;
      }
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange svg:last-child{
        animation:cfV15ArrowNudge 2.4s ease-in-out infinite;
      }

      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost{
        position:relative!important;
        overflow:hidden!important;
        border:1px solid rgba(145,224,250,.62)!important;
        background:linear-gradient(120deg,rgba(16,47,58,.52),rgba(44,139,166,.42),rgba(103,199,234,.22),rgba(16,47,58,.52))!important;
        background-size:240% 100%!important;
        color:#fff!important;
        box-shadow:0 10px 26px rgba(7,49,65,.22),0 0 24px rgba(103,199,234,.08) inset!important;
        backdrop-filter:blur(10px)!important;
        -webkit-backdrop-filter:blur(10px)!important;
        transition:transform .28s ease,border-color .28s ease,box-shadow .28s ease!important;
        animation:cfV15BlueFlow 6.2s ease-in-out infinite!important;
      }
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost:hover,
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost:focus-visible{
        transform:translateY(-2px) scale(1.008)!important;
        border-color:rgba(185,238,255,.88)!important;
        box-shadow:0 15px 34px rgba(7,49,65,.30),0 0 30px rgba(103,199,234,.16) inset,0 0 22px rgba(103,199,234,.12)!important;
      }
      body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost svg:first-child{
        animation:cfV15PhonePulse 3.1s ease-in-out infinite;
      }

      @keyframes cfV15OrangeFlow{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
      @keyframes cfV15BlueFlow{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
      @keyframes cfV15Shine{0%,58%{transform:skewX(-18deg) translateX(-220%)}76%,100%{transform:skewX(-18deg) translateX(610%)}}
      @keyframes cfV15ArrowNudge{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}
      @keyframes cfV15PhonePulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}

      /* PATHS — mobile carousel tuning from visual QA */
      @media(max-width:649px){
        body.template-casa-facile-shop .cf-paths__cards{
          grid-auto-columns:minmax(164px,46vw)!important;
          gap:8px!important;
          padding:3px 8vw 8px 2px!important;
          scroll-padding-inline:5vw!important;
          overscroll-behavior-inline:contain;
          -webkit-overflow-scrolling:touch;
          scrollbar-width:none!important;
        }
        body.template-casa-facile-shop .cf-paths__cards::-webkit-scrollbar{
          display:none!important;
          width:0!important;
          height:0!important;
        }
        body.template-casa-facile-shop .cf-path-tile{
          position:relative!important;
          isolation:isolate;
          scroll-snap-align:start!important;
          scroll-snap-stop:always;
          transform:translateY(0) scale(.965);
          opacity:.78;
          filter:saturate(.90) brightness(.985);
          border:1px solid rgba(16,47,58,.11)!important;
          box-shadow:0 8px 21px rgba(16,47,58,.085)!important;
          transition:transform .36s cubic-bezier(.2,.72,.2,1),opacity .28s ease,filter .28s ease,box-shadow .36s ease,border-color .28s ease!important;
        }
        body.template-casa-facile-shop .cf-path-tile::after{
          content:"";
          position:absolute;
          inset:0;
          z-index:3;
          pointer-events:none;
          border-radius:inherit;
          opacity:0;
          background:linear-gradient(118deg,transparent 18%,rgba(255,255,255,.32) 43%,transparent 62%);
          transform:translateX(-120%);
        }
        body.template-casa-facile-shop .cf-path-tile.is-cf-path-focus{
          transform:translateY(-2px) scale(1.01)!important;
          opacity:1!important;
          filter:saturate(1.055) brightness(1.018)!important;
          z-index:2;
        }
        body.template-casa-facile-shop .cf-path-tile.is-cf-path-focus::after{
          opacity:.52;
          animation:cfV15CardShine 3.2s ease-in-out infinite;
        }
        body.template-casa-facile-shop .cf-path-tile:nth-child(1).is-cf-path-focus{
          border-color:rgba(103,199,234,.72)!important;
          box-shadow:0 14px 30px rgba(16,47,58,.14),0 0 0 2px rgba(103,199,234,.12)!important;
        }
        body.template-casa-facile-shop .cf-path-tile:nth-child(2).is-cf-path-focus{
          border-color:rgba(245,124,32,.68)!important;
          box-shadow:0 14px 30px rgba(16,47,58,.14),0 0 0 2px rgba(245,124,32,.11)!important;
        }
        body.template-casa-facile-shop .cf-path-tile:nth-child(3).is-cf-path-focus{
          border-color:rgba(24,185,91,.64)!important;
          box-shadow:0 14px 30px rgba(16,47,58,.14),0 0 0 2px rgba(24,185,91,.10)!important;
        }
        body.template-casa-facile-shop .cf-path-tile.is-cf-path-focus img{
          transform:scale(1.012)!important;
          transition:transform 2.7s ease!important;
        }
      }

      @media(max-width:390px){
        body.template-casa-facile-shop .cf-paths__cards{
          grid-auto-columns:minmax(158px,46.5vw)!important;
          gap:7px!important;
        }
      }

      @keyframes cfV15CardShine{0%,58%{transform:translateX(-120%)}80%,100%{transform:translateX(120%)}}

      @media(prefers-reduced-motion:reduce){
        body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange,
        body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange::before,
        body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--orange svg:last-child,
        body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost,
        body.template-casa-facile-shop #main-content.cfm-hero .cfm-button--ghost svg:first-child,
        body.template-casa-facile-shop .cf-path-tile,
        body.template-casa-facile-shop .cf-path-tile::after,
        body.template-casa-facile-shop .cf-path-tile img{
          animation:none!important;
          transition:none!important;
          transform:none!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const setupPathsCarousel = (track) => {
    if (!track || initializedTracks.has(track)) return;
    const cards = [...track.querySelectorAll('.cf-path-tile')];
    if (cards.length < 2) return;
    initializedTracks.add(track);

    let activeIndex = 0;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(cards.length - 1, index));
      cards.forEach((card, i) => card.classList.toggle('is-cf-path-focus', i === activeIndex));
    };

    const closestToCenter = () => {
      const t = track.getBoundingClientRect();
      const center = t.left + t.width / 2;
      let best = 0;
      let distance = Infinity;
      cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const d = Math.abs((r.left + r.width / 2) - center);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    };

    const revealCard = (index, smooth = true) => {
      const card = cards[index];
      if (!card) return;
      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const targetLeft = track.scrollLeft + (cardRect.left - trackRect.left) - 8;
      track.scrollTo({ left: Math.max(0, targetLeft), behavior: smooth ? 'smooth' : 'auto' });
      setActive(index);
    };

    createCasaFacileAutoplay(track, {
      mobile: mobileMq,
      reduced: reduceMq,
      interval: AUTO_MS,
      pauseMs: USER_PAUSE_MS,
      advance: () => revealCard((activeIndex + 1) % cards.length, true),
      update: () => {
        if (!mobileMq.matches || reduceMq.matches) {
          cards.forEach((card) => card.classList.remove('is-cf-path-focus'));
          if (!mobileMq.matches && track.scrollLeft) track.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          setActive(closestToCenter());
        }
      },
      dispose: () => initializedTracks.delete(track)
    });
  };

  const boot = () => {
    injectStyles();
    document.querySelectorAll('.cf-paths__cards').forEach(setupPathsCarousel);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    injectStyles();
    event.target?.querySelectorAll?.('.cf-paths__cards').forEach(setupPathsCarousel);
  });
})();

/* ==========================================================================\n   CASA FACILE — PREMIUM COMPACT CARD MODEL v16\n   Official visual model for product + collection cards on the Casa Facile home.\n   Keeps Theme Editor images as the source of truth.\n   ========================================================================== */
(() => {
  if (window.CasaFacilePremiumCardV16) return;
  window.CasaFacilePremiumCardV16 = true;

  const body = document.body;
  if (!body?.classList.contains('template-casa-facile-shop')) return;

  const STYLE_ID = 'cf-premium-card-model-v16';
  const css = `
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card{
      position:relative!important;
      isolation:isolate!important;
      min-height:0!important;
      padding:0!important;
      overflow:hidden!important;
      display:flex!important;
      flex-direction:column!important;
      gap:0!important;
      border:1px solid rgba(103,199,234,.30)!important;
      border-radius:22px!important;
      background:
        radial-gradient(circle at 8% 4%,rgba(103,199,234,.13),transparent 28%),
        radial-gradient(circle at 96% 2%,rgba(245,124,32,.10),transparent 24%),
        linear-gradient(165deg,#fff 0%,#fbfdfe 58%,#f2f8fa 100%)!important;
      box-shadow:0 14px 34px rgba(16,47,58,.10),inset 0 1px 0 rgba(255,255,255,.92)!important;
      transition:transform .32s cubic-bezier(.2,.75,.2,1),box-shadow .32s ease,border-color .32s ease,filter .32s ease!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card::before{
      content:""!important;
      position:absolute!important;
      inset:0 14% auto!important;
      z-index:8!important;
      display:block!important;
      height:3px!important;
      border-radius:0 0 99px 99px!important;
      background:linear-gradient(90deg,#67c7ea 0%,rgba(103,199,234,.58) 34%,rgba(245,124,32,.76) 72%,#f57c20 100%)!important;
      box-shadow:0 2px 10px rgba(103,199,234,.20),0 2px 10px rgba(245,124,32,.14)!important;
      animation:none!important;
      pointer-events:none!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card::after{
      content:""!important;
      position:absolute!important;
      inset:0!important;
      z-index:7!important;
      display:block!important;
      pointer-events:none!important;
      border-radius:inherit!important;
      background:linear-gradient(115deg,transparent 18%,rgba(255,255,255,.32) 44%,transparent 64%)!important;
      transform:translateX(-130%)!important;
      opacity:0!important;
    }

    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header{
      order:1!important;
      position:relative!important;
      z-index:2!important;
      width:100%!important;
      min-width:0!important;
      padding:14px 15px 10px!important;
      text-align:center!important;
      background:transparent!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__badge{
      min-height:25px!important;
      width:fit-content!important;
      max-width:96%!important;
      display:inline-flex!important;
      align-items:center!important;
      justify-content:center!important;
      margin:0 auto 7px!important;
      padding:5px 10px!important;
      border:1px solid rgba(103,199,234,.38)!important;
      border-radius:999px!important;
      background:linear-gradient(110deg,rgba(235,249,253,.95),rgba(255,255,255,.96) 58%,rgba(255,242,231,.92))!important;
      color:#183e4b!important;
      box-shadow:0 5px 14px rgba(16,47,58,.06),inset 0 1px 0 #fff!important;
      font-size:10.2px!important;
      line-height:1.05!important;
      letter-spacing:.055em!important;
      font-weight:800!important;
      text-transform:uppercase!important;
      white-space:nowrap!important;
      overflow:hidden!important;
      text-overflow:ellipsis!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header h3{
      width:100%!important;
      max-width:100%!important;
      min-width:0!important;
      margin:0!important;
      padding:0!important;
      color:#102f3a!important;
      font-size:17px!important;
      line-height:1.1!important;
      letter-spacing:-.03em!important;
      font-weight:760!important;
      text-align:center!important;
      white-space:nowrap!important;
      overflow:visible!important;
      text-overflow:clip!important;
      text-shadow:none!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header h3 a{
      display:block!important;
      width:100%!important;
      color:inherit!important;
      white-space:inherit!important;
    }

    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__media{
      order:2!important;
      position:relative!important;
      z-index:1!important;
      width:calc(100% - 20px)!important;
      min-height:0!important;
      aspect-ratio:16/9!important;
      margin:0 10px!important;
      overflow:hidden!important;
      border:1px solid rgba(16,47,58,.08)!important;
      border-radius:16px!important;
      background:#eaf2f5!important;
      box-shadow:0 10px 24px rgba(16,47,58,.09),inset 0 1px 0 rgba(255,255,255,.72)!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__media .cfm-image{
      display:block!important;
      width:100%!important;
      height:100%!important;
      object-fit:cover!important;
      object-position:center!important;
      transform:scale(1.01)!important;
      filter:saturate(1.015) contrast(1.01)!important;
      transition:transform .52s cubic-bezier(.2,.75,.2,1),filter .4s ease!important;
    }

    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__body{
      order:3!important;
      position:relative!important;
      z-index:2!important;
      min-height:0!important;
      display:flex!important;
      flex:1 1 auto!important;
      flex-direction:column!important;
      align-items:center!important;
      padding:9px 14px 13px!important;
      text-align:center!important;
      background:transparent!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__body>p{
      display:-webkit-box!important;
      width:94%!important;
      max-width:38ch!important;
      margin:0 auto!important;
      overflow:hidden!important;
      -webkit-box-orient:vertical!important;
      -webkit-line-clamp:2!important;
      color:#52656e!important;
      font-size:12.75px!important;
      line-height:1.34!important;
      font-weight:500!important;
      text-align:center!important;
      text-shadow:none!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__footer{
      width:100%!important;
      min-height:0!important;
      display:flex!important;
      flex-direction:column!important;
      align-items:center!important;
      justify-content:center!important;
      gap:7px!important;
      margin-top:7px!important;
      padding-top:7px!important;
      border-top:1px solid rgba(16,47,58,.07)!important;
    }
    html body.template-casa-facile-shop #soluzioni .cfm-official-card__footer--collection{
      justify-content:center!important;
      border-top:0!important;
      padding-top:5px!important;
    }
    html body.template-casa-facile-shop #pacchetti .cfm-official-card__price{
      color:#d95c00!important;
      font-size:19px!important;
      line-height:1!important;
      letter-spacing:-.025em!important;
      font-weight:850!important;
      white-space:nowrap!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__cta{
      position:relative!important;
      overflow:hidden!important;
      min-width:142px!important;
      min-height:44px!important;
      display:inline-flex!important;
      align-items:center!important;
      justify-content:center!important;
      gap:8px!important;
      margin:0 auto!important;
      padding:0 16px!important;
      border:1px solid rgba(185,71,0,.10)!important;
      border-radius:14px!important;
      background:linear-gradient(110deg,#f57c20 0%,#ff9b47 48%,#f57c20 100%)!important;
      background-size:210% 100%!important;
      color:#102f3a!important;
      box-shadow:0 9px 20px rgba(245,124,32,.24),inset 0 1px 0 rgba(255,255,255,.30)!important;
      font-size:12.8px!important;
      line-height:1!important;
      font-weight:850!important;
      white-space:nowrap!important;
      transition:transform .24s ease,box-shadow .24s ease,filter .24s ease,background-position .5s ease!important;
    }
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__cta:hover,
    html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__cta:focus-visible{
      transform:translateY(-2px)!important;
      filter:saturate(1.05) brightness(1.025)!important;
      background-position:100% 50%!important;
      box-shadow:0 13px 26px rgba(245,124,32,.32),0 0 20px rgba(245,124,32,.13)!important;
    }

    html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4){
      color:#102f3a!important;
    }

    @media(hover:hover) and (pointer:fine){
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:hover,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:focus-within{
        transform:translateY(-5px) scale(1.008)!important;
        border-color:rgba(103,199,234,.52)!important;
        box-shadow:0 22px 48px rgba(16,47,58,.14),0 0 26px rgba(103,199,234,.09)!important;
        filter:none!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:hover::after,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:focus-within::after{
        opacity:.72!important;
        animation:cfPremiumCardSweepV16 .85s ease-out 1!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:hover .cfm-official-card__media .cfm-image,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card:focus-within .cfm-official-card__media .cfm-image{
        transform:scale(1.045)!important;
        filter:saturate(1.05) brightness(1.015)!important;
      }
    }

    @media(max-width:640px){
      html body.template-casa-facile-shop #soluzioni .cfm-card-grid,
      html body.template-casa-facile-shop #pacchetti .cfm-package-grid{
        display:grid!important;
        grid-template-columns:none!important;
        grid-auto-flow:column!important;
        grid-auto-columns:min(86vw,360px)!important;
        gap:11px!important;
        overflow-x:auto!important;
        overscroll-behavior-inline:contain!important;
        scroll-snap-type:x mandatory!important;
        scroll-padding-inline:4vw!important;
        padding:4px 10vw 11px 1px!important;
        -webkit-overflow-scrolling:touch!important;
        scrollbar-width:none!important;
      }
      html body.template-casa-facile-shop #soluzioni .cfm-card-grid::-webkit-scrollbar,
      html body.template-casa-facile-shop #pacchetti .cfm-package-grid::-webkit-scrollbar{display:none!important;width:0!important;height:0!important}
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card,
      html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4){
        grid-column:auto!important;
        display:flex!important;
        width:100%!important;
        min-width:0!important;
        min-height:0!important;
        flex-direction:column!important;
        scroll-snap-align:start!important;
        scroll-snap-stop:always!important;
        border-radius:20px!important;
      }
      html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4) .cfm-official-card__media{
        width:calc(100% - 18px)!important;
        height:auto!important;
        min-height:0!important;
        aspect-ratio:16/9!important;
        margin:0 9px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header,
      html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4) .cfm-official-card__header{
        order:1!important;
        padding:11px 12px 8px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__badge{
        min-height:22px!important;
        margin-bottom:5px!important;
        padding:4px 8px!important;
        font-size:9.4px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header h3,
      html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4) .cfm-official-card__header h3{
        font-size:15px!important;
        line-height:1.06!important;
        letter-spacing:-.032em!important;
        white-space:nowrap!important;
        overflow:visible!important;
        text-overflow:clip!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__media{
        order:2!important;
        width:calc(100% - 18px)!important;
        aspect-ratio:16/9!important;
        margin:0 9px!important;
        border-radius:15px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__body,
      html body.template-casa-facile-shop #soluzioni .cfm-official-card:nth-child(4) .cfm-official-card__body{
        order:3!important;
        padding:8px 12px 11px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__body>p{
        width:94%!important;
        max-width:35ch!important;
        margin:0 auto!important;
        font-size:12.15px!important;
        line-height:1.28!important;
        -webkit-line-clamp:2!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__footer{
        gap:6px!important;
        margin-top:5px!important;
        padding-top:6px!important;
      }
      html body.template-casa-facile-shop #pacchetti .cfm-official-card__price{
        font-size:18px!important;
      }
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__cta{
        min-width:132px!important;
        min-height:44px!important;
        padding:0 14px!important;
        border-radius:13px!important;
        font-size:12.4px!important;
      }
    }

    @media(max-width:380px){
      html body.template-casa-facile-shop #soluzioni .cfm-card-grid,
      html body.template-casa-facile-shop #pacchetti .cfm-package-grid{grid-auto-columns:min(88vw,338px)!important}
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__header h3{font-size:14.2px!important}
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__body>p{font-size:11.9px!important}
    }

    @keyframes cfPremiumCardSweepV16{
      from{transform:translateX(-130%)}
      to{transform:translateX(130%)}
    }

    @media(prefers-reduced-motion:reduce){
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card::after,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__media .cfm-image,
      html body.template-casa-facile-shop :is(#soluzioni,#pacchetti) .cfm-official-card__cta{
        animation:none!important;
        transition:none!important;
      }
    }
  `;

  const injectStyles = () => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
    }
    style.textContent = css;
    document.head.appendChild(style);
  };

  const detectProductCategory = (card) => {
    const link = card.querySelector('.cfm-official-card__header h3 a')?.getAttribute('href') || '';
    const title = card.querySelector('.cfm-official-card__header h3')?.textContent || '';
    const key = `${link} ${title}`.toLowerCase();
    if (/farett|sottopensile|binario|lampad|illuminaz|\bled\b/.test(key)) return 'ILLUMINAZIONE LED';
    if (/tapparell|termostat|cronotermostat|domotic|controllo.?carichi|carichi/.test(key)) return 'DOMOTICA & SMART HOME';
    if (/induzion|salvavita|restart|quadro|sicurezza|wallbox/.test(key)) return 'IMPIANTO & SICUREZZA';
    return 'CASA FACILE';
  };

  const applyCategoryBadges = (scope = document) => {
    scope.querySelectorAll?.('#pacchetti .cfm-official-card--product').forEach((card) => {
      const badge = card.querySelector('.cfm-official-card__badge');
      if (!badge) return;
      const category = detectProductCategory(card);
      badge.textContent = category;
      badge.dataset.cfCategory = category;
      badge.setAttribute('aria-label', `Categoria ${category}`);
    });
  };

  const fitTitles = (scope = document) => {
    const compact = window.matchMedia('(max-width:640px)').matches;
    const maxSize = compact ? 15 : 17;
    const minSize = compact ? 11.6 : 12.5;
    scope.querySelectorAll?.(':is(#soluzioni,#pacchetti) .cfm-official-card__header h3').forEach((title) => {
      title.style.fontSize = `${maxSize}px`;
      let size = maxSize;
      let guard = 0;
      while (title.scrollWidth > title.clientWidth && size > minSize && guard < 24) {
        size -= .25;
        title.style.fontSize = `${size}px`;
        guard += 1;
      }
    });
  };

  let resizeTimer = 0;
  const refresh = (scope = document) => {
    injectStyles();
    applyCategoryBadges(scope);
    requestAnimationFrame(() => fitTitles(scope));
  };

  const boot = () => {
    refresh();
    window.setTimeout(() => refresh(), 180);
    window.setTimeout(() => refresh(), 650);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => fitTitles(), 120);
  }, { passive:true });

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => refresh(event.target || document), 80);
  });
})();

/* CASA FACILE — Mobile card balance + slow autoplay v13 */
(() => {
  if (window.CasaFacileMobileCarouselV13) return;
  window.CasaFacileMobileCarouselV13 = true;

  const body = document.body;
  if (!body?.classList.contains('template-casa-facile-shop')) return;

  const mobile = window.matchMedia('(max-width: 640px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const INTERVAL = 3800;
  const USER_PAUSE = 7000;
  const selectors = [
    '#soluzioni .cfm-card-grid',
    '#pacchetti .cfm-package-grid'
  ];

  if (!document.getElementById('cf-mobile-card-balance-v13')) {
    const style = document.createElement('style');
    style.id = 'cf-mobile-card-balance-v13';
    style.textContent = `
      @media(max-width:640px){
        html body.template-casa-facile-shop #soluzioni .cfm-card,
        html body.template-casa-facile-shop #pacchetti .cfm-package{
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__header,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__header{
          display:flex!important;
          flex-direction:column!important;
          align-items:center!important;
          justify-content:center!important;
          padding:10px 12px 6px!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__header h3,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__header h3,
        html body.template-casa-facile-shop #soluzioni .cfm-card h3,
        html body.template-casa-facile-shop #pacchetti .cfm-package h3{
          display:block!important;
          width:100%!important;
          min-height:0!important;
          margin:0 auto!important;
          overflow:visible!important;
          white-space:normal!important;
          text-overflow:clip!important;
          -webkit-line-clamp:unset!important;
          line-clamp:unset!important;
          font-size:1.5rem!important;
          line-height:1.16!important;
          text-align:center!important;
          text-wrap:balance;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__badge,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__badge{
          align-self:center!important;
          min-height:22px!important;
          margin:0 auto 5px!important;
          padding:3px 7px!important;
          font-size:.82rem!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__media,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__media{
          width:calc(100% - 8px)!important;
          aspect-ratio:17/10!important;
          margin:0 4px!important;
          border-radius:14px!important;
          overflow:hidden!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__media img,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__media img{
          width:100%!important;
          height:100%!important;
          object-fit:cover!important;
          object-position:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__body,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__body{
          display:flex!important;
          flex-direction:column!important;
          align-items:center!important;
          padding:7px 12px 11px!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__body>p,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__body>p{
          display:-webkit-box!important;
          width:92%!important;
          min-height:0!important;
          margin:0 auto 6px!important;
          overflow:hidden!important;
          -webkit-box-orient:vertical!important;
          -webkit-line-clamp:2!important;
          font-size:1.3rem!important;
          line-height:1.28!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__price,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__price{
          width:100%!important;
          margin-left:auto!important;
          margin-right:auto!important;
          font-size:1.72rem!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__footer,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__footer{
          display:flex!important;
          flex-direction:column!important;
          align-items:center!important;
          justify-content:center!important;
          width:100%!important;
          gap:6px!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-official-card__cta,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__cta{
          align-self:center!important;
          justify-content:center!important;
          min-height:44px!important;
          padding:8px 12px!important;
          border-radius:11px!important;
          font-size:1.2rem!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-card-grid>.cfm-card,
        html body.template-casa-facile-shop #pacchetti .cfm-package-grid>.cfm-package{
          transform-origin:center center!important;
          transition:transform .55s cubic-bezier(.2,.8,.2,1),box-shadow .55s ease,filter .55s ease!important;
        }

        html body.template-casa-facile-shop #soluzioni .cfm-card-grid>.cfm-card.is-cf-carousel-focus,
        html body.template-casa-facile-shop #pacchetti .cfm-package-grid>.cfm-package.is-cf-carousel-focus{
          transform:translateY(-1px) scale(1.015)!important;
          filter:saturate(1.035) brightness(1.008)!important;
          box-shadow:0 14px 30px rgba(16,47,58,.15),0 0 0 1px rgba(103,199,234,.16) inset!important;
          z-index:2!important;
        }

        html body.template-casa-facile-shop #soluzioni .is-cf-carousel-focus .cfm-official-card__media img,
        html body.template-casa-facile-shop #pacchetti .is-cf-carousel-focus .cfm-official-card__media img{
          transform:scale(1.01)!important;
          transition:transform .62s cubic-bezier(.2,.8,.2,1)!important;
        }
      }

      @media(prefers-reduced-motion:reduce){
        html body.template-casa-facile-shop #soluzioni .cfm-card-grid>.cfm-card,
        html body.template-casa-facile-shop #pacchetti .cfm-package-grid>.cfm-package,
        html body.template-casa-facile-shop #soluzioni .cfm-official-card__media img,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__media img{
          transition:none!important;
          transform:none!important;
          filter:none!important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const getCards = (track) => [...track.children].filter((item) => !item.hasAttribute('data-cf-carousel-clone'));

  const getStep = (track) => {
    const first = getCards(track)[0];
    if (!first) return 0;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  };

  const updateFocus = (track) => {
    if (!mobile.matches || reduced.matches || !track?.isConnected) {
      getCards(track || { children: [] }).forEach((card) => card.classList.remove('is-cf-carousel-focus'));
      return;
    }

    const cards = getCards(track);
    if (!cards.length) return;
    const rect = track.getBoundingClientRect();
    const center = rect.left + rect.width / 2;
    let closest = null;
    let distance = Infinity;

    cards.forEach((card) => {
      const cardRect = card.getBoundingClientRect();
      const delta = Math.abs((cardRect.left + cardRect.width / 2) - center);
      if (delta < distance) {
        distance = delta;
        closest = card;
      }
    });

    cards.forEach((card) => card.classList.toggle('is-cf-carousel-focus', card === closest));
  };

  const setupTrack = (track) => {
    if (!track || track.dataset.cfAutoplayV13 === '1' || track.children.length < 2) return;
    track.dataset.cfAutoplayV13 = '1';

    const advance = () => {
      const cards = getCards(track);
      const step = getStep(track);
      if (cards.length < 2 || !step) return;

      const current = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step)));
      const next = (current + 1) % cards.length;
      track.scrollTo({ left: next * step, behavior: 'smooth' });
    };

    createCasaFacileAutoplay(track, {
      mobile,
      reduced,
      interval: INTERVAL,
      pauseMs: USER_PAUSE,
      advance,
      update: () => updateFocus(track),
      dispose: () => { delete track.dataset.cfAutoplayV13; }
    });
  };

  const init = () => selectors.forEach((selector) => setupTrack(body.querySelector(selector)));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 80));
})();

/* Keep the former V14 compact-description layer after V13; V16 refresh remains authoritative. */
(() => {
  if (!document.body?.classList.contains('template-casa-facile-shop')) return;
  const injectCompactDescriptions = () => {
    if (document.getElementById('cf-mobile-description-v14')) return;
    const style = document.createElement('style');
    style.id = 'cf-mobile-description-v14';
    style.textContent = `
      @media(max-width:640px){
        html body.template-casa-facile-shop #soluzioni .cfm-official-card__body>p,
        html body.template-casa-facile-shop #pacchetti .cfm-official-card__body>p{
          width:90%!important;
          margin:0 auto 5px!important;
          font-size:12.5px!important;
          line-height:1.22!important;
          font-weight:500!important;
          -webkit-line-clamp:2!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  injectCompactDescriptions();
})();

})();

/* ==========================================================================\n   CASA FACILE — PRODUCT-FIRST PACKAGE IMAGERY v17\n   Package cards prioritize product/result imagery; Andrea remains in trust/story.\n   ========================================================================== */
(() => {
  if (window.CasaFacileProductFirstCardsV17) return;
  window.CasaFacileProductFirstCardsV17 = true;

  const PRODUCT_IMAGES = {
    '/products/kit-luce-sottopensile-cucina-professional': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/rn-image_picker_lib_temp_d1102fb9-7539-4839-99dd-db82f3751f92.png?v=1786202915',
      alt: 'Kit luce sottopensile cucina LED Casa Facile'
    },
    '/products/installazione-4-faretti-led-incasso-monza-brianza': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/installazione-4-faretti-led-incasso-monza-brianza.webp?v=1785541037',
      alt: 'Quattro faretti LED da incasso Casa Facile'
    },
    '/products/tapparelle-smart-ave-installate': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/cf-sm-004-pacchetti-tapparelle-smart-monza-brianza_81e6202a-e432-4d77-a393-1a6731fd4594.webp?v=1786465262',
      alt: 'Pacchetto tapparelle smart AVE Casa Facile'
    },
    '/products/termostato-smart-wifi-ave-installato-monza-brianza': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/rn-image_picker_lib_temp_3b9a866d-f2c7-4d3b-a9f8-e2d5fcbb18eb.png?v=1786205164',
      alt: 'Termostato smart Wi-Fi AVE Casa Facile'
    },
    '/products/kit-linea-piano-induzione-installazione': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/CF-IND-001_IMG-01-HERO_v1.webp?v=1787092405',
      alt: 'Kit linea dedicata piano a induzione Casa Facile'
    },
    '/products/salvavita-riarmo-automatico-installazione': {
      url: 'https://cdn.shopify.com/s/files/1/0814/6675/3364/files/casa-facile-salvavita-gewiss-restart-pro-cover-1200x1200_8f80906a-b556-4010-a27b-2c96a6720740.jpg?v=1787620776',
      alt: 'Salvavita GEWISS ReStart PRO Casa Facile'
    }
  };

  const applyProductFirstImages = (scope = document) => {
    scope.querySelectorAll?.('#pacchetti .cfm-official-card--product').forEach((card) => {
      const link = card.querySelector('.cfm-official-card__header h3 a')?.getAttribute('href') || '';
      const entry = Object.entries(PRODUCT_IMAGES).find(([path]) => link.includes(path));
      if (!entry) return;
      const image = card.querySelector('.cfm-official-card__media img');
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = entry[1].url;
      image.alt = entry[1].alt;
      image.dataset.cfProductFirst = '1';
    });
  };

  const boot = () => {
    applyProductFirstImages();
    window.setTimeout(() => applyProductFirstImages(), 180);
    window.setTimeout(() => applyProductFirstImages(), 700);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => applyProductFirstImages(event.target || document), 80);
  });
})();
